// WhatsAppMessageFormatter.jsx
import React, { useMemo } from "react";

const WhatsAppMessageFormatter = ({ text, className = "" }) => {

  const formatWhatsAppText = useMemo(() => {
    if (!text) return "";

    let formattedText = text;

    // Replace formatting markers with JSX elements
    // Bold: *text* -> <strong>text</strong>
    formattedText = formattedText.replace(
      /\*([^*]+)\*/g,
      '<strong class="font-semibold">$1</strong>'
    );

    // Italic: _text_ -> <em>text</em>
    formattedText = formattedText.replace(
      /_([^_]+)_/g,
      '<em class="italic">$1</em>'
    );

    // Strikethrough: ~text~ -> <del>text</del>
    formattedText = formattedText.replace(
      /~([^~]+)~/g,
      '<del class="line-through opacity-75">$1</del>'
    );

    // Monospace: `````` -> <code>text</code>
    formattedText = formattedText.replace(
      /``````/g,
      '<code class="bg-white/10 px-1 py-0.5 rounded text-sm font-mono">$1</code>'
    );

    // Convert real line breaks (from textarea) to <br> tags
    // This handles actual Enter key presses in textarea
    formattedText = formattedText.replace(/\n/g, "<br />");

    return formattedText;
  }, [text]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: formatWhatsAppText }}
    />
  );
};

export default WhatsAppMessageFormatter;
